import { render, staticRenderFns } from "./WorkFunctionsItemRename.vue?vue&type=template&id=6be20426&"
import script from "./WorkFunctionsItemRename.vue?vue&type=script&lang=js&"
export * from "./WorkFunctionsItemRename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports